var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.253 10.789c-.186.142-3.467 1.968-3.467 6.028 0 4.697 4.175 6.358 4.3 6.4-.019.1-.663 2.275-2.201 4.49-1.371 1.95-2.804 3.896-4.983 3.896s-2.74-1.25-5.255-1.25c-2.451 0-3.323 1.291-5.316 1.291s-3.384-1.803-4.982-4.019C1.496 25.024 0 20.982 0 17.147c0-6.153 4.05-9.415 8.036-9.415 2.119 0 3.884 1.373 5.214 1.373 1.266 0 3.24-1.456 5.65-1.456.912 0 4.194.083 6.353 3.14m-7.498-5.744c.997-1.168 1.702-2.789 1.702-4.409 0-.225-.02-.452-.061-.636-1.622.06-3.55 1.067-4.714 2.399-.913 1.025-1.765 2.646-1.765 4.288 0 .247.041.494.06.573.103.019.27.041.436.041 1.455 0 3.285-.962 4.342-2.256"
  })));
};
export default SvgApple;